// extracted by mini-css-extract-plugin
export var bodySections = "_8c-8";
export var gray = "_8c-7";
export var green = "_8c-4";
export var iconContainer = "_8c-9";
export var iconWidgetContainer = "_8c-1";
export var phoneIcon = "_8c-2";
export var red = "_8c-5";
export var statusDot = "_8c-3";
export var widgetContainer = "_8c-0";
export var yellow = "_8c-6";